import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SimpleBarScroll from "components/SimpleBar";
import PaymentTypeCreate from "pages/payments/PaymentCreate";
import React from "react";

const PaymentEditDialog = ({ open, handleClose, paymentType }) => {
  return (
    <CustomDialog
      forceFullScreen={true}
      open={open}
      handleClose={handleClose}
      heading="Edit payment"
    >
      <Box sx={{ overflow: "hidden" }}>
        <SimpleBarScroll>
          <Box padding={2}>
            <PaymentTypeCreate paymentType={paymentType} fullGrid={false} />
          </Box>
        </SimpleBarScroll>
      </Box>
    </CustomDialog>
  );
};

export default PaymentEditDialog;
